<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{ 'Turbo.TroubleshootRepurchase.Header' | translate:'Why not repurchased?' }}">
    <div *ngIf="!isLoading">
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.IsFinanced" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.IsFinanced" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootRepurchase.IsFinanced' | translate:'Is financed?' }}</div>
      </div>
      <div class="dots-container">
        <div class="dot"></div>
      </div>
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.HaveDllContractId" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.HaveDllContractId" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootRepurchase.HaveDllContractId' | translate:'Have DLL contractId?' }}</div>
      </div>
      <div class="dots-container">
        <div class="dot"></div>
      </div>
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.TerminationCreated" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.TerminationCreated" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootRepurchase.TerminationCreated' | translate:'Termination created?' }}</div>
      </div>
      <div class="dots-container">
        <div class="dot"></div>
      </div>
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.IsNotInsurance" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.IsNotInsurance" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootRepurchase.IsNotInsurance' | translate:'Is not insurance?' }}</div>
      </div>
      <div class="dots-container">
        <div class="dot"></div>
      </div>
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.BuybackDatePassed" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.BuybackDatePassed" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootRepurchase.BuybackDatePassed' | translate:'Buyback date passed?' }}</div>
      </div>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate" style="margin-left: -15px; position: absolute; width: calc(100% + 30px); top: 0px;"></mat-progress-bar>
  </t4-container>
</mat-dialog-content>

